export default "__VITE_ASSET__CFcqwHt4__"